import { createSelector } from 'reselect';
import pathsManifest from 'app/shared/pathsManifest';
import browserUtils from 'app/shared/utils/browserUtils';
import constellationBrowserUtils from 'app/shared/utils/constellationBrowserUtils';

const getApp = state => state.app;

const AppSelectors = {
    makeApp: createSelector([getApp], app => app),
    makeBrand: createSelector([getApp], app => app.brand),
    makeClientLoaded: createSelector([getApp], app => app.clientLoaded),
    makeCookieEnabledServices: createSelector([getApp], app => app.cookieEnabledServices),
    makeHostname: createSelector([getApp], app => app.hostname),
    makeHostApp: createSelector([getApp], app => app.cookieEnabledServices.hostApp),
    makeUserAgent: createSelector([getApp], app => app.userAgent),
    makePrevPath: createSelector([getApp], app => app.prevPath),
    makeIsDev: createSelector([getApp], app => app.isDev),
    makeIsOnline: createSelector([getApp], app => app.isOnline),
    makeIsMobile: createSelector([getApp], app => app.isMobile),
    makeIsScreenMobile: createSelector([getApp], (app) => {
        const screenType = browserUtils.screen.type(app.screenSize);
        return screenType === browserUtils.screenType.MOBILE;
    }),
    makeIsScreenTabletOrDesktop: createSelector([getApp], app => (
        app.screenSize === browserUtils.screenSize.LG || app.screenSize === browserUtils.screenSize.XL
    )),
    makeIsScreenXS: createSelector([getApp], app => app.screenSize === browserUtils.screenSize.XS),
    /*
     * makeIsScreenSM
     *
     * is screen size small (< 768px)
     */
    makeIsScreenSM: createSelector([getApp], app => app.screenSize === browserUtils.screenSize.SM),
    makeIsScreenConstellationMobile: createSelector([getApp], (app) => {
        const screenType = constellationBrowserUtils.screen.type(app.constellationScreenSize);
        return screenType === constellationBrowserUtils.screenType.MOBILE;
    }),
    makeIsScreenConstellationTablet: createSelector([getApp], (app) => {
        const screenType = constellationBrowserUtils.screen.type(app.constellationScreenSize);
        return screenType === constellationBrowserUtils.screenType.TABLET;
    }),
    makeIsScreenConstellationLG: createSelector([getApp], (app) => {
        const screenSize = constellationBrowserUtils.screen.size(app.constellationScreenSize);
        return screenSize === constellationBrowserUtils.screenSize.LG;
    }),
    makeIsSOH: createSelector([getApp], app => app.isSOH),
    makePaths: createSelector([getApp], app => pathsManifest.getAllPaths(app.brand)),
    makeIp: createSelector([getApp], app => app.ip),
    makeCsrfToken: createSelector([getApp], app => app.csrfToken),
};

export default AppSelectors;
